export const NotificationVariant = {
    ERROR: 'error',
    SUCCESS: 'success',
};